import React, { useContext } from 'react'
import styled from '@emotion/styled'

import { EmailCaptureForm } from '../EmailCaptureForm'
import { BlockMonogram } from '../svgs/BlockMonogram'
import { SiteConfigContext } from '../SiteConfigProvider'
import { descriptionText, EmailSignUpContainer, FormContainer, headerText } from './'

const ContainerLayout = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;

	${({ theme }) => theme.MQ.XL} {
		flex-direction: row;
	}
`
const ContextContainer = styled.div`
	display: flex;
	color: ${({ theme }) => theme.colors.primary};
	flex-direction: row;
	flex-flow: row wrap;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;
	${({ theme }) => theme.MQ.XL} {
		max-width: 50%;
		flex-direction: column;
		flex-flow: column wrap;
	}
`
const ContextHeader = styled.div`
	${({ theme }) => theme.fonts.header};
	font-size: 24px;
	letter-spacing: 0.65px;
	line-height: 28px;
	margin-left: 1.5rem;
	${({ theme }) => theme.MQ.M} {
		font-size: 24px;
	}
`
const DescriptionText = styled.div`
	letter-spacing: 0.55px;
	padding: 0.5rem;
`
const HeaderContainer = styled.div`
	align-items: center;
	display: inline-flex;
`

export function EmailSignUpMessagingBoxBdc() {
	const {
		siteConstants: {
			EMAIL_CAPTURE_SOURCES: { article },
		},
	} = useContext(SiteConfigContext)

	return (
		<EmailSignUpContainer>
			<ContainerLayout>
				<ContextContainer>
					<HeaderContainer>
						<BlockMonogram width={100} height={100} />
						<ContextHeader>{headerText}</ContextHeader>
					</HeaderContainer>
					<DescriptionText>{descriptionText}</DescriptionText>
				</ContextContainer>
				<FormContainer>
					<EmailCaptureForm source={article} />
				</FormContainer>
			</ContainerLayout>
		</EmailSignUpContainer>
	)
}
